export const formatToDateAndTime = (date: Date) => {
  return new Date(date).toLocaleString('de-De', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  });
};

export const formatToDateWithoutTime = (date: Date) => {
  return new Date(date).toLocaleString('de-De', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatToDateWithoutTimeWith2DigitYear = (date: Date) => {
  return new Date(date).toLocaleString('de-De', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  });
};

export const formatToTime = (date: Date) => {
  return new Date(date).toLocaleString('de-De', {
    hour: 'numeric',
    minute: 'numeric'
  });
};

export const formatToISODateWithoutTime = (date: Date) => {
  const tempDate = new Date(date);
  tempDate.setHours(12, 0, 0, 0);
  return tempDate.toISOString().split('T')[0];
};
